// KL - aircond general service.
const content = {
    slug: 'aircond-general-service',
    title: (c) => `Aircond General Service KL from ${c.money(c.tables.general[0].wall)} | Wall & Cassette`,
    description: (c) =>
        `Aircond general service in KL from ${c.money(c.tables.general[0].wall)} per unit: filter, coil, blower and drain cleaned. Cheaper per unit when you service the whole house.`,
    eyebrow: 'KL · General service',
    h1: 'Aircond General Service in KL',
    lead: (c) =>
        `The regular service that keeps your aircond cold, quiet and drip-free. ${c.money(c.tables.general[0].wall)} for one wall-mounted unit; ${c.money(c.tables.general[2].wall)} for three - book every bedroom together.`,
    image: 'blog/living/dirty-aircon-filters.jpg',
    imageAlt: 'Aircond filter full of dust before a general service',
    facts: ['Every 3-4 months', 'About 45 minutes per unit', 'Wall and cassette'],
    priceTitle: 'General service prices',
    priceIntro: 'Covers wall-mounted units up to 2.0hp. Ceiling cassettes take longer and are priced separately.',
    panel: { type: 'servicing', services: ['general'], defaultMount: 'Wall' },
    sections: [
        {
            // Target of the hero card's Service Details link
            id: 'included',
            title: 'What we clean',
            items: [
                'Filters and front panel washed.',
                'Coil surface brushed and rinsed with water.',
                'Blower wheel cleaned where reachable without dismantling.',
                'Drain tray and drain pipe flushed to stop drips.',
                'Outdoor unit fins and fan checked and cleaned where safely reachable.',
                'Remote, louvres and operating temperature checked at the end.',
            ],
            columns: 2,
        },
        {
            title: 'Is a general service enough?',
            tone: 'muted',
            cards: [
                { title: 'Yes, if...', body: 'The unit still cools well and there is no smell. A general service every few months keeps it that way.' },
                { title: 'Upgrade to chemical wash if...', body: 'You smell "aircond bau", see black spots on the louvres, or water drips even after a service.' },
                { title: 'Consider an overhaul if...', body: 'The unit hasn\'t been serviced for years, or a chemical wash didn\'t remove the smell.' },
            ],
        },
        {
            title: 'Small habits that stretch the time between services',
            paragraphs: [
                'Rinse the filters every two to four weeks under a tap and let them dry before putting them back. Set bedroom units to 24-25°C rather than 16°C - the room is just as comfortable overnight and your TNB bill drops. Close windows while the aircond runs, especially during afternoon rain, so the unit isn\'t fighting damp outdoor air.',
            ],
        },
    ],
    faqs: [
        {
            question: 'How much is aircond general service in KL?',
            answer: (c) => `${c.money(c.tables.general[0].wall)} for one unit, ${c.money(c.tables.general[1].wall)} for two, ${c.money(c.tables.general[2].wall)} for three and ${c.money(c.tables.general[4].wall)} for five wall-mounted units.`,
        },
        {
            question: 'How long does a general service take?',
            answer: 'About 45 minutes per wall-mounted unit. A three-bedroom condo with four units is usually done in two to three hours.',
        },
        {
            question: 'Do I need to move furniture?',
            answer: 'Clear the bed or desk directly under the unit if you can. The technician uses a cover bag to catch the water.',
        },
        {
            question: 'Is "normal service" the same as general service?',
            answer: 'Yes - shops in Malaysia call it normal service, basic service or general service. It is the water-based clean, without chemicals.',
        },
    ],
    schema: {
        name: 'Aircond General Service in Kuala Lumpur',
        serviceType: 'Air conditioner cleaning',
        offers: (c) => [
            { name: 'General service, 1 unit', price: c.tables.general[0].wall },
            { name: 'General service, 2 units', price: c.tables.general[1].wall },
            { name: 'General service, 3 units', price: c.tables.general[2].wall },
            { name: 'General service, 5 units', price: c.tables.general[4].wall },
        ],
    },
}

export default content
